import React, { Fragment, useState } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import man from "../../assets/ovah/PDF-01.png";
// import bg from "../../assets/ovah/bg.png"; // Assuming this is your background image
import { ForgotPassword } from "../../myConstants";
import axios from "axios";
import { setUserInfo } from "../../features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "../../AbstractElements";
import apiRequest from "../../utils/apiRequest";
const Signin = ({ selected }) => {
  const [email, setEmail] = useState("admin@gmail.com");
  const [password, setPassword] = useState("test123");
  const [togglePassword, setTogglePassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  const [name, setName] = useState(localStorage.getItem("Name"));
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const Data = [
    {
      id: 2,
      heading: "Loader 3",
      spinnerClass: "loader-3",
    },
  ];
  const loginAuth = async (e) => {
    e.preventDefault();
    setValue(man);
    setName("Emay Walter");
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/users/login`,
        {
          email: email,
          password: password,
        }
      );

      if (response.data.statusCode == 200 && (response.data.data.user.role === "admin" || response.data.data.user.role === "sub-admin")) {
        dispatch(setUserInfo(response.data.data));
        await new Promise((resolve) => setTimeout(resolve, 100));
        toast.success("Successfully logged in!..");
        setLoader(false);
        const fetchData = async (token = response.data.data.accessToken, id) => {
          try {

            const response = await apiRequest(
              'get',
              `${process.env.REACT_APP_API_BASE_URL}/users/profile`,
              {},  // Pass an empty object as data for GET requests
              token
            );

            console.log("🚀 ~ fetchData ~ response:", response)

          } catch (error) {
            console.error("Error fetching data: ", error);

          }
        };
        const res = await fetchData()
        setTimeout(() => {
          navigate(`/dashboard`);

        }, 2000);
      } else if (response.data.statusCode == 200 && (response.data.data.user.role !== "admin" || response.data.data.user.role === "sub-admin")) {
        toast.error("Only Admin Can Access It!..");
        setLoader(false);

      } else {
        toast.error("You entered the wrong password or username!..");
      }
    } catch (error) {
      toast.error("You entered the wrong password or username!..");

      setLoader(false);
    }
  };



  return (
    <Fragment>
      <ToastContainer position="top-right" />
      <Container fluid>
        <Row
          className="justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Col xs="12" sm="8" md="6" lg="4">
            <div
              className="card p-4"

            >
              {/* <div className="text-center mb-4">
                <img
                  src={man}
                  alt="logo"
                  style={{ height: "100px", width: "auto" }}
                />
              </div> */}
              <div className="text-left mb-4">
                <h4
                  style={{
                    fontFamily: "Arial, Open Sans",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                  }}
                >
                  {loader && (
                    <div className="loader-box">
                      <Spinner
                        attrSpinner={{ className: Data[0].spinnerClass }}
                      />
                    </div>
                  )}
                  Log in
                </h4>
                <h5
                  style={{
                    fontFamily: "Arial, Open Sans",
                    fontSize: "12px",
                    fontWeight: "normal",
                  }}
                >
                  Welcome Back!
                </h5>
              </div>
              <Form>
                <FormGroup>
                  <Input
                    type="email"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    style={{
                      backgroundColor: "#f2f2f2",
                      border: "none",
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    type={togglePassword ? "text" : "password"}
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    style={{
                      backgroundColor: "#f2f2f2",
                      border: "none",
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  />
                </FormGroup>
                <FormGroup check className="mt-2">
                  <Label
                    check
                    style={{ fontSize: "14px", fontWeight: "normal" }}
                  >
                    <Input
                      defaultChecked
                      type="checkbox"
                      color="black"
                      style={{
                        transform: "scale(1.2)",
                        marginRight: "5px",
                        backgroundColor: "grey",
                        borderColor: "black",
                        color: "black",
                      }}
                    />{" "}
                    Remember Password
                  </Label>
                </FormGroup>
                <button
                  className="btn btn-custom w-100 mt-4"
                  onClick={(e) => loginAuth(e)}
                  style={{
                    backgroundColor: "#000",
                    borderRadius: "18px",
                    border: "none",
                    color: "#fff",
                    padding: "10px 20px",
                    fontSize: "16px",
                  }}
                >
                  Log in
                </button>
                <div className="text-center" style={{ marginTop: "40px" }}>
                  <Link
                    to={`/forgot-password`}
                    style={{
                      marginLeft: "5px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {ForgotPassword}
                  </Link>
                </div>
              </Form>

            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Signin;
